module.exports = __webpack_public_path__ + "media/images/icon-radio-selected-02708c09dc0d821e4221ecb0bbe27ee0.svg";